import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    CHWIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={CHWIconImg} preview={false}/>
